import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { tag } from 'rxjs-spy/operators';

import { ITimeMarker } from 'vbrick-player-src/videogular/controls/VbTimeMarkers.Component';
import { SecondMs } from 'rev-shared/date/Time.Constant';

import { IUserTag, ITimeRange } from './IUserTag';
import { VideoPlaybackService } from '../VideoPlayback.Service';

@Injectable({
	providedIn: 'root'
})
export class VideoUserTagsService {
	private activeUserTagSubject$: BehaviorSubject<IUserTag> = new BehaviorSubject<IUserTag>(undefined);

	public usersTag$: Observable<IUserTag[]>;
	public activeUserTag$: Observable<IUserTag>;
	public activeUserTagMarkers$: Observable<ITimeMarker[]>;

	constructor(
		VideoPlaybackSvc: VideoPlaybackService
	) {
		this.usersTag$ = VideoPlaybackSvc.video$.pipe(
			map<any, IUserTag[]>(video => video && video.userTags || []),
			shareReplay({ bufferSize: 1, refCount: true }),
			tag('usersTag$')
		);

		this.activeUserTag$ = this.activeUserTagSubject$.asObservable();

		this.activeUserTagMarkers$ = this.activeUserTag$.pipe(
			map<IUserTag, ITimeMarker[]>(tag => tag ? this.shapeTimeMarker(tag.timeRanges) : []),
			tag('activeUserTagMarkers$')
		);
	}

	public toggleActiveUserTag(userTag?: IUserTag): void {
		const existingTag: IUserTag = this.activeUserTagSubject$.value || {} as IUserTag;
		this.activeUserTagSubject$.next(userTag && userTag.userId !== existingTag.userId ? userTag : undefined);
	}

	public clearActiveUserTag(): void {
		this.activeUserTagSubject$.next(undefined);
	}

	private shapeTimeMarker(timeRanges: ITimeRange[]): ITimeMarker[] {
		return timeRanges.map(range => (
			{
				startTime: range.startTimeMs / SecondMs,
				endTime: range.endTimeMs / SecondMs,
				cssClassName: 'time-range-display'
			}
		));
	}

}
